<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.83374 1.54199H7.08374C7.7596 1.54203 8.14228 1.65254 8.40991 1.80859C8.68511 1.96915 8.89425 2.20777 9.18335 2.5918L10.4333 4.25879C10.5467 4.40987 10.6956 4.624 10.9246 4.74609C11.1604 4.87168 11.4254 4.875 11.6667 4.875H14.1667C15.987 4.875 17.0002 5.16062 17.5867 5.74707C18.1731 6.33352 18.4587 7.34671 18.4587 9.16699V14.167C18.4587 15.9873 18.1731 17.0005 17.5867 17.5869C17.0002 18.1734 15.987 18.459 14.1667 18.459H5.83374C4.01346 18.459 2.99929 18.1734 2.41284 17.5869C1.82661 17.0004 1.54175 15.9869 1.54175 14.167V5.83398C1.54175 4.0137 1.82639 2.99953 2.41284 2.41309C2.99929 1.82664 4.01346 1.54199 5.83374 1.54199ZM5.83374 1.79199C5.08114 1.79199 4.44541 1.82685 3.92163 1.9375C3.39227 2.04934 2.9413 2.24596 2.59351 2.59375C2.24571 2.94154 2.04909 3.39251 1.93726 3.92188C1.82661 4.44566 1.79175 5.08138 1.79175 5.83398V14.167C1.79175 14.9196 1.82659 15.5553 1.93726 16.0791C2.0491 16.6084 2.24576 17.0595 2.59351 17.4072C2.94127 17.7549 3.39237 17.9507 3.92163 18.0625C4.44543 18.1732 5.08109 18.209 5.83374 18.209H14.1667C14.9194 18.209 15.5551 18.1732 16.0789 18.0625C16.6081 17.9507 17.0593 17.7549 17.407 17.4072C17.7547 17.0595 17.9504 16.6083 18.0623 16.0791C18.1729 15.5553 18.2087 14.9196 18.2087 14.167V9.16699C18.2087 8.41434 18.1729 7.77868 18.0623 7.25488C17.9504 6.72567 17.7547 6.27447 17.407 5.92676C17.0593 5.57904 16.6081 5.38333 16.0789 5.27148C15.5551 5.16082 14.9194 5.125 14.1667 5.125H11.6667C11.1908 5.125 10.9323 5.04394 10.7595 4.94238C10.5786 4.83603 10.4366 4.67743 10.2312 4.40625L8.98315 2.74219V2.74121L8.83276 2.54297C8.67833 2.34443 8.50517 2.14976 8.27124 2.0166C7.94735 1.83231 7.56662 1.79201 7.08374 1.79199H5.83374Z"
      fill="#667085"
      stroke="#667085"
    />
  </svg>
</template>

<script>
export default {
  name: "FolderIcon",

  data() {
    return {};
  },
  computed: {},
};
</script>